import React from 'react';
import { AlertCircle } from 'lucide-react';
import { mockData, images } from '../utils/mock';

export const RealMoment = () => {
  return (
    <section className="relative py-24 bg-gradient-to-b from-black to-zinc-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
              {mockData.realMoment.title}
            </h2>
            <p className="text-xl text-white/80 mb-8 leading-relaxed">
              {mockData.realMoment.description}
            </p>

            <div className="space-y-4 mb-10">
              <p className="text-lg text-white/70 font-medium mb-4">Aparecen:</p>
              {mockData.realMoment.challenges.map((challenge, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 group"
                >
                  <div className="w-1.5 h-1.5 rounded-full bg-orange-500 group-hover:scale-150 transition-transform duration-300"></div>
                  <p className="text-lg text-white/90 group-hover:text-white group-hover:translate-x-2 transition-all duration-300">
                    {challenge}
                  </p>
                </div>
              ))}
            </div>

            <div className="space-y-4 p-6 border-l-4 border-orange-500 bg-gradient-to-r from-orange-500/10 to-transparent rounded-r-lg">
              {mockData.realMoment.conclusion.map((line, index) => (
                <p
                  key={index}
                  className={`text-lg ${
                    index === 0
                      ? 'text-white/80'
                      : 'text-white font-semibold'
                  }`}
                >
                  {line}
                </p>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl group">
              <img
                src={images.familySupport}
                alt="Momento real del fútbol"
                className="w-full h-[500px] object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-orange-500/20 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
